export var validateOtpMapper = function (data, hashStr) {
    var result = {
        message: "Something went wrong.please try again later",
        status: false,
    };
    if (data !== null &&
        data !== undefined &&
        data.hashStr !== undefined &&
        data.hashStr !== null &&
        data.hashStr !== undefined &&
        data.hashStr !== "" &&
        data.hashStr === hashStr) {
        result = {
            message: data === null || data === void 0 ? void 0 : data.message,
            status: data === null || data === void 0 ? void 0 : data.success,
        };
    }
    return result;
};
